import { CtaButton, Link } from '@tkww/orion-web-ds-action';
import { TextBody, TextTitle } from '@tkww/orion-web-ds-text';
import React from 'react';
import Styles from './styles.scss';

const HELP_URL = 'https://helpcenter.theknot.com/hc/en-us/requests/new';

interface ErrorStepProps {
	onRetry: () => void;
}

export const ErrorStep = ({ onRetry }: ErrorStepProps) => {
	return (
		<div className={Styles.errorStep} data-testid="error-step">
			<div className={Styles.content}>
				<TextTitle size="lg">An unexpected error happened.</TextTitle>
				<div className={Styles.description}>
					<TextBody size="md">Please try again. Need some help?</TextBody>
					<Link href={HELP_URL} target="_blank">
						Get assistance
					</Link>
				</div>
			</div>
			<CtaButton className={Styles.ctaButton} size="lg" onClick={onRetry}>
				Try again
			</CtaButton>
		</div>
	);
};
